import { render, staticRenderFns } from "./ComplexBackgroundBig.vue?vue&type=template&id=8701e614&scoped=true"
import script from "./ComplexBackgroundBig.vue?vue&type=script&lang=ts"
export * from "./ComplexBackgroundBig.vue?vue&type=script&lang=ts"
import style0 from "./ComplexBackgroundBig.vue?vue&type=style&index=0&id=8701e614&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8701e614",
  null
  
)

export default component.exports